import { atom } from 'jotai';

export type QuoteOfferingLoadingPromise = {
  operation: 'create' | 'update' | 'delete' | 'revert' | 'remove';
  quoteId: string;
  quoteOfferingId?: string | null;
  promise: Promise<unknown>;
};

export const quoteOfferingLoadingPromises = atom<QuoteOfferingLoadingPromise[]>(
  [],
);
